import { Component, type ErrorInfo, type ReactNode } from 'react';

import { useI18n } from '../i18n/I18nProvider';
import { Button } from './ui/Button';
import { Typography } from './ui/Typography';

function ApplicationErrorFallback() {
  const { t } = useI18n();
  return (
    <main className="app-error-fallback" role="alert">
      <div className="app-error-fallback-card">
        <Typography as="p" className="app-error-fallback-eyebrow" variant="body-xs">
          MRM
        </Typography>
        <Typography as="h1" variant="sh-m">
          {t('appErrorTitle')}
        </Typography>
        <Typography as="p" variant="body-m">
          {t('appErrorDescription')}
        </Typography>
        <Button onClick={() => window.location.reload()} type="button">
          {t('appErrorReload')}
        </Button>
      </div>
    </main>
  );
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  override state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Application render failed', error, info.componentStack);
  }

  override render(): ReactNode {
    return this.state.hasError ? <ApplicationErrorFallback /> : this.props.children;
  }
}
